export default __webpack_public_path__ + "44eb07970d48a60fd3bb710dcf6ec465.png";